import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SnackbarWarningIcon = forwardRef<SVGSVGElement, IconProps>(function SnackbarWarningIcon(
  { color = '#EC984B', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0009 8.52133C12.4349 8.52133 12.7867 8.87698 12.7867 9.31569V14.6114C12.7867 15.0501 12.4349 15.4057 12.0009 15.4057C11.5669 15.4057 11.2151 15.0501 11.2151 14.6114V9.31569C11.2151 8.87698 11.5669 8.52133 12.0009 8.52133Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M12.0009 22.4598H5.65165C2.01601 22.4598 0.496793 19.8332 2.25699 16.624L5.52593 10.6717L8.60627 5.07944C10.4712 1.67961 13.5306 1.67961 15.3956 5.07944L21.7449 16.6346C23.5051 19.8438 21.9754 22.4704 18.3502 22.4704H12.0009V22.4598Z"
        fill="url(#paint0_linear_389_22866)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0009 3.05914C11.0319 3.05914 9.9455 3.73002 9.06441 5.33625L2.71514 16.8808C1.89071 18.384 1.89323 19.6344 2.38266 20.4773C2.87182 21.3197 3.94891 21.9303 5.65165 21.9303H12.0009C12.0368 21.9303 12.0718 21.9339 12.1057 21.9409H18.3502C20.0472 21.9409 21.1249 21.3306 21.6155 20.4875C22.1062 19.6442 22.1109 18.3941 21.2869 16.8916L14.9377 5.33669C14.0566 3.73046 12.97 3.05914 12.0009 3.05914ZM11.8962 22.9894H5.65165C3.71874 22.9894 2.2184 22.2867 1.47909 21.0134C0.740074 19.7407 0.863194 18.0731 1.79883 16.3672L8.14812 4.82262C9.13198 3.02934 10.5079 2 12.0009 2C13.4941 2 14.8699 3.02903 15.8537 4.82262L22.2029 16.3776C23.1389 18.0841 23.259 19.7521 22.5186 21.0245C21.7781 22.2969 20.2784 23 18.3502 23H12.0009C11.9651 23 11.93 22.9964 11.8962 22.9894Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9474 17.7888C10.9474 17.2038 11.4165 16.7296 11.9951 16.7296H12.0045C12.5832 16.7296 13.0523 17.2038 13.0523 17.7888C13.0523 18.3737 12.5832 18.8479 12.0045 18.8479H11.9951C11.4165 18.8479 10.9474 18.3737 10.9474 17.7888Z"
        fill={color || 'currentColor'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_389_22866"
          x1="12"
          y1="2"
          x2="23.2446"
          y2="23.6245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA337" stopOpacity="0.3" />
          <stop offset="1" stopColor="#FFA337" stopOpacity="0.3" />
        </linearGradient>
      </defs>
    </svg>
  );
});
